import { Content, IndicatorActive } from './indicator.styled';

export { IndicatorActive };

export const Indicator = (props) => {
  const { onClick, className, active } = props;
  return (
    <Content onClick={onClick} className={className}>
      {active && <IndicatorActive className={className} />}
    </Content>
  );
};
